module.exports = __webpack_public_path__ + "static/media/curveend.775d7aed.svg";